import React from 'react'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { APP_ROUTES } from '../../../common/constants'

import { useLoggedInUser } from '../../hooks'

const GuestRedirect = ({ children }) => {
  const user = useLoggedInUser()

  return !user ? children : <Navigate to={APP_ROUTES.MENUS.fullPath} replace />
}

GuestRedirect.propTypes = {
  children: PropTypes.node.isRequired,
}

export default GuestRedirect
